export default __webpack_public_path__ + "static/blog-2-6a41c5e4bd02cdeecaf79fd1483679a9.jpg";